import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Signup } from '../../Pages/Signup';
import CorporateSignupFlow from './CorporateSignupFlow';
import { getLocalStorageItem } from '../../Utils/Helper';

const SignupRoute = () => {
  const isAuthenticated = useSelector((state) => state?.Login?.isAuthenticated);
  const whitelabelDataFromRedux = useSelector((state) => state?.GetWhitelabel?.whitelabelDataWithID);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const referralCode = searchParams.get("ref");

  // Get whitelabel data from Redux or LocalStorage
  const localData = getLocalStorageItem("whitelabelData");
  const groupName = whitelabelDataFromRedux?.groupName || localData?.groupName;
  
  // Check groupName
  const isCorporate = groupName === 'MoneyplantFX';

  if (isAuthenticated && location.pathname !== "/verifyemail") {
    return <Navigate to="/" />;
  }

  if (isCorporate) {
    return <CorporateSignupFlow />;
  }

  return <Signup referralCode={referralCode} />;
};

export default SignupRoute;
